export const WHATSAPP_NUMBER = "5547988464621";
export const PHONE_DISPLAY = "(47) 98846-4621";
export const BRAND = "NVS Automotiva";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MESSAGE =
  "Olá! Preciso de socorro de auto elétrica 24h. Podem me atender agora?";
